<div class="div2">
  <div class="grid-container2">
    <mat-form-field>
      <mat-label>BUSCAR</mat-label>
      <input
        matInput
        (keyup)="filtroDataSource($event)"
        placeholder="INGRESE DATO A BUSCAR"
      />
    </mat-form-field>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="cargando"></mat-progress-bar>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="opciones">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>OPCIONES</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-mini-fab
          [color]="colorBoton || null"
          [attr.style]="estiloBoton || null"
          (click)="onVerDetalle(element.id)"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="numSerie">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>NÚMERO DE SERIE</th>
      <td mat-cell *matCellDef="let element">{{ element.serial }}</td>
    </ng-container>

    <ng-container matColumnDef="tipo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>TIPO</th>
      <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
    </ng-container>

    <ng-container matColumnDef="modelo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>MODELO</th>
      <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
    </ng-container>

    <ng-container matColumnDef="fabricante">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>FABRICANTE</th>
      <td mat-cell *matCellDef="let element">{{ element.manufacturers_id }}</td>
    </ng-container>

    <ng-container matColumnDef="sucursalStatus">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [matTooltip]="tooltipEstatus"
      >
        {{ tituloEstatus }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ obtenerValorEstatus(element) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="fecha_mod">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        ÚLTIMA MODIFICACIÓN
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.date_mod?.substring(0, 10) }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnas"></tr>
    <tr mat-row *matRowDef="let row; columns: columnas"></tr>
  </table>

  <div class="no-result" *ngIf="!cargando && !length">Sin resultados.</div>

  <mat-paginator
    class="mat-elevation-z8"
    [length]="length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    (page)="onPage($event)"
    showFirstLastButtons
  ></mat-paginator>
</div>
